import { FC } from 'react';
import './new-button.scss';
import '@app/index.scss';

export interface IButtonProps {
  variant?: 'black' | 'white' | 'outline' | 'outline-cancel';
  size?: 'big' | 'medium' | 'small';
  addClass?: string;
  noBorder?: boolean;
  icon: React.ReactNode;
  onClick?: () => void;
  disable?: boolean;
}

export const NewButtonIcon: FC<IButtonProps> = ({
  variant = 'black',
  size = 'big',
  addClass = '',
  noBorder = false,
  icon,
  onClick = () => {},
  disable = false,
}) => {
  return (
    <button
      type="button"
      className={`new-button new-button--icon new-button--${variant} new-button--${size} ${addClass} ${
        noBorder ? 'new-button--no-border' : ''
      }${disable ? 'new-button--disable' : ''}`}
      onClick={onClick}
    >
      <div className="new-button__icon">{icon}</div>
    </button>
  );
};
